export default __webpack_public_path__ + "cabd033726613ed42ce8b8b2a524ad5c.svg";